import React from "react";
import img1 from "../assets/gcap.png";
import { AcademicCapIcon } from "@heroicons/react/solid";
import img2 from "../assets/bag.png";

const Education = () => {
  return (
    <section id="education">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-2">
          <AcademicCapIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            Education
          </h1>
        </div>
        <div className="flex flex-wrap w-full ">
          <div className="mx-auto">
            <div className="flex relative pb-12">
              <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
              </div>
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-500 inline-flex items-center justify-center text-white relative z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>
              <div className="flex-grow pl-4">
                <div className="flex max-w-md mx-auto overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 my-2">
                  <div className="w-1/3 bg-cover bg-gray-400 text-center py-2">
                    <img
                      alt="Graduation"
                      className="bg-green-300 m-auto rounded-full h-20 w-20"
                      src={img1}
                    />
                    <h3>2019-2023</h3>{" "}
                  </div>
                  <div className="w-2/3 p-4 md:p-4">
                    <h1 className="text-2xl font-bold text-gray-800 dark:text-white">
                      NSUT EAST CAMPUS{" "}
                    </h1>

                    <p className="mt-2 text-left text-sm text-gray-600 dark:text-gray-400">
                      Bachelor of Technology, Computer Science & Engineering
                      (2019-2023) <br />
                      Current CGPA: 9.0/10
                    </p>
                  </div>
                </div>
              </div>
            </div>{" "}
            <div className="flex relative">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-500 inline-flex items-center justify-center text-white relative z-10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>
              </div>
              <div className="flex-grow pl-4">
                <div className="flex max-w-md mx-auto overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 my-2">
                  <div className="w-1/3 bg-cover bg-gray-400 text-center py-2">
                    <img
                      alt="Graduation"
                      className="bg-green-300 m-auto rounded-full h-20 w-20"
                      src={img2}
                    />
                    <h3>2016-2018</h3>{" "}
                  </div>
                  <div className="w-2/3 p-4 md:p-4">
                    <h1 className="text-2xl font-bold text-gray-800 dark:text-white">
                      Camford Public School{" "}
                    </h1>

                    <p className="mt-2 text-left  font-normal text-gray-600 dark:text-gray-400">
                      Intermediate <br />
                      Score: 88%
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
